<template lang="pug">
    #storekeeper-freights.center-panel.md-scrollbar.md-theme-default
        .md-layout.heading
        md-content.md-elevation-1(md-theme="white")
            storekeepers-menu
            //.md-flex(md-theme="white")
            //md-button.md-dense.md-primary(v-bind:to="{ name: 'StorekeepersFreight', params: {id: 'new'} }") Принять груз
            //md-button.md-dense.md-accent(v-bind:to="{ name: 'StorekeepersIssueFreight'}") Выдать груз
            sort-table(
                v-bind:columns="tableColumns"
                v-bind:link="true" v-model="freights"
                v-bind:per-page="perPage"
                v-bind:total="freightAmount"
                default-order="desc"
                v-on:refresh="getFreights"
                table-id="storekeepers-freights-table"
                ref="storekeepers-freights-table"
                tableHeight="calc(100% - 48px)"
                v-bind:showAddButton="false"
                v-bind:refreshOnCreate="false"
                v-bind:loadOnScroll="true"
                v-bind:noBreackColumns="['traking_number', 'id']"
            )

                template(slot="id" slot-scope="scope")
                    span {{ scope.item.traking_number }}

                template(slot="weight" slot-scope="scope") 
                    span {{ (scope.item.weight) ? scope.item.weight : 'Не установлен'}}

                template(slot="size" slot-scope="scope") 
                    span {{ (scope.item.size) ? scope.item.size : 'Не установлен' }}

                template(slot="seats_number" slot-scope="scope") 
                    span {{ (scope.item.seats_number) ? scope.item.seats_number : 'Не установлен' }}


                template(slot="status" slot-scope="scope")
                    span(v-if="scope.item.status" v-bind:style="'color: ' + scope.item.status.color") {{ scope.item.status.name }}
                    span(v-if="!scope.item || !scope.item.status") Не установлен
                
                template(slot="from" slot-scope="scope")
                    div(v-if="scope.item.deal && (scope.item.deal.from_stock || scope.item.deal.from_address)")
                        span(v-if="scope.item.deal.from_stock") {{scope.item.deal.from_stock.name}}
                        span(v-if="scope.item.deal.from_address") {{scope.item.deal.from_address.address}}
                    div(v-else)
                        span(v-if="scope.item.deal && scope.item.deal.from_city") {{scope.item.deal.from_city.name}}
                    
                template(slot="to" slot-scope="scope")
                    div(v-if="scope.item.deal && (scope.item.deal.to_stock || scope.item.deal.to_address)")
                        span(v-if="scope.item.deal.to_stock") {{scope.item.deal.to_stock.name}}
                        span(v-if="scope.item.deal.to_address") {{scope.item.deal.to_address.address}}
                    div(v-else)
                        span(v-if="scope.item.deal && scope.item.deal.to_city") {{scope.item.deal.to_city.name}}

                template(slot="actions" slot-scope="scope")
                    //span
                        md-button.md-icon-button.md-dense(v-if="scope.item.deal_id" v-bind:to="{ name: 'DealEdit', params: {dealid: scope.item.deal_id} }"): md-icon content_paste
                        md-tooltip(md-direction="top") К заявке
                //template(slot="deal_id" slot-scope="scope")
                    span( v-if="scope.item.deal && scope.item.deal.traking_number") {{scope.item.deal.traking_number}}
                    span( v-if="!scope.item.deal || !scope.item.deal.traking_number") Не установлен
                template(slot="buttons")
                    .button-container
                        md-button.md-dense.md-primary(v-bind:to="{ name: 'StorekeepersFreight', params: {id: 'new'} }") Принять груз
                        md-button.md-dense.md-accent(v-bind:to="{ name: 'StorekeepersIssueFreight'}") Выдать груз

</template>
<script>
    import moment from "moment";
    import SortTable from "@/components/SortTable";
    import StorekeepersMenu from "./storekeepers-menu";
    export default {
        components: {SortTable, StorekeepersMenu},
        metaInfo() {
            return {
                title: 'Грузы'
            }
        },
        data() {
            return {
                title: 'Грузы',
                perPage: 50,
                tableColumns: [
                    { label: 'Номер груза', field: 'id', sortable: true },
                    { label: 'Вес (кг)', field: 'weight' },
                    { label: 'Объём (м<sup>3</sup>)', field: 'size' },
                    { label: 'Мест', field: 'seats_number' },
                    { label: 'Отправление', field: 'from', sortable: true },
                    { label: 'Назначение', field: 'to', sortable: true },
                    { label: 'Статус', field: 'status', sortable: true },
                    //{ label: 'Дата забора', field: 'departure_date', sortable: true },
                    { label: 'Описание', field: 'description', sortable: true },
                    { label: '', field: 'actions' },
                ],
            }
        },
        watch: {
        },
        methods: {
            getFilter() {
                let stocksIdArray = this.stocks.map(stock => stock.id);
                let model = (this.$route.query.search) ? [['traking_number', '%', this.$route.query.search]] : [];
                let result = {
                    model: model,
                    relation: [['currenttracking', 'stock_id', '=', stocksIdArray]]
                };
                return result;
            },
            /**
             * Получение грузов, которые сейчас находятся на одном из складов,
             * к которым привязан текущий пользователь
             */
            getFreights(page, count, orderBy, orderType, r, reload) {
                if (!this.stocks || !this.stocks.length) return;
                this.$store.commit('storekeepers_stocks/setCurrentFreightPage', page);
                this.$store.dispatch('storekeepers_stocks/getFreights', {
                    page: page, order_by: orderBy, order_type: orderType, count: count,
                    filter: this.getFilter(), concat: !reload
                });
            },
            /**
             * Получение складов, к которым привязан текущий пользователь
             */
            getStorekeepersStocks() {
                if (!this.user || !this.user.id) return;
                this.$store.dispatch('storekeepers_stocks/getStorekeepersStocks', {
                    page: 1, count: 'all',
                    filter: {model: [], relation: [['responsibles', 'id', '=', this.user.id]]}
                }).then(r => {
                    if (r) this.getFreights(1, this.perPage, 'id', 'desc');
                });
            }
        },
        computed: {
            user() {
                return this.$store.state.users.current;
            },
            stocks() {
                return this.$store.state.storekeepers_stocks.stocks;
            },
            logged() {
                return this.$store.state.users.logedIn;
            },
            freights() {
                let freights = Object.assign([], this.$store.state.storekeepers_stocks.freights);
                if (!freights || !freights.length) return [];
                freights = freights.map(item => {
                    item.routerLink = {name: 'StorekeepersFreight', params: {id: item.id}};
                    return item;
                });
                return freights;
            },
            freightAmount() {
                return this.$store.state.storekeepers_stocks.freights_amount;
            },
        },
        created() {
            this.$nextTick(() => {
                this.$root.isAuth().then(
                    () => this.getStorekeepersStocks(),
                    () => this.$router.push({name: 'Login'})
                );
            });
            this.$store.commit('setBigSizePanel');
        }
    }
</script>
<style lang="sass" src="./freight.sass"></style>



// WEBPACK FOOTER //
// Freights.vue?8658f256